<template>
  <div class="questionnaire-question-content">

    <div class="questionnaire-question-abstrait">
      <img :src="require(`@/assets/img/question/raisonnement/${image}`)">
    </div>

    <div class="questionnaire-question-question">
      Sélectionnez la suite logique :
    </div>

    <div class="questionnaire-question-abstrait-responses">
      <div v-for="proposition of propositions" :key="proposition">
        <div v-if="this.answer == proposition" :value=proposition class="questionnaire-question-abstrait-responses-element--selected" tabindex="0" v-on:click="focus">
          <img :id='proposition' :src="require(`@/assets/img/question/raisonnement/${proposition}`)">
        </div>
        <div v-else :value=proposition class="questionnaire-question-abstrait-responses-element" tabindex="0" v-on:click="focus">
          <img :id='proposition' :src="require(`@/assets/img/question/raisonnement/${proposition}`)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "RaisonnementLogiqueTest",
  components: {},
  props: {
    question: String,
    subQuestion: String,
    propositions: Array,
    image: String
  },
  data() {
    return {
      idElement: "",
      answer: null
    }
  },
  methods: {
    changeOnField: function (event) {
      this.$emit.response = event.target.value
    },
    focus: function (event) {
      var actual = document.getElementsByClassName('questionnaire-question-abstrait-responses-element--selected')[0]
      if (actual != undefined) {
        actual.classList.remove('questionnaire-question-abstrait-responses-element--selected')
        actual.classList.add('questionnaire-question-abstrait-responses-element')
      }
      event.currentTarget.classList.toggle('questionnaire-question-abstrait-responses-element--selected')
      event.currentTarget.classList.toggle('questionnaire-question-abstrait-responses-element')
      this.answer = event.currentTarget.getAttribute('value')
    }

  },
  mounted() {
    var domainId = this.$parent.domainId
    var indexQuestion = this.$parent.indexQuestion

    UserService.getUserTestQuestions(domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
